import { render, staticRenderFns } from "./CalculationForm.vue?vue&type=template&id=8678ca5a&"
import script from "./CalculationForm.vue?vue&type=script&lang=ts&"
export * from "./CalculationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports